<ngx-spinner></ngx-spinner>
<section class="promotional_sect login-page">
  <a routerLink="" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <a href="javascript:void(none)" routerLink="/login" class="back-arrow"
      ><span class="icon-arrow-left"></span
    ></a>
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2 class="mb-2 font-bold">Welcome to Intelligens</h2>
            <h4 class="mb-2 font-bold">
              Stream real shows. Real shows that matter
            </h4>
            <h6 class="content-desk mb-3">
              This is your new home for reality shows with no scripts and
              documentaries with no filters. At Intelligens, we are dedicated to
              bringing you content that is not only entertaining but will also
              offer you a look into worlds you didn't even know existed. Join us
              today and become a part of the Intelligens family.
            </h6>
            <a
              routerLink="/login"
              href="javascript:void(0)"
              class="btn btn-theme text-capitalize"
            >
              {{ "SIGNUP_INFO.BACK_TO_LOGIN" | translate }}</a
            >
          </div>
        </div>

        <div class="right-login">
          <div class="w-100">
            <form
              class="login"
              (ngSubmit)="onSubmit(signForm.valid)"
              #signForm="ngForm"
            >
              <div class="ul-tab mr-2 mb-2 text-center">
                <ul>
                  <li>
                    <a
                      [ngClass]="{ active: registerByMobile }"
                      href="javascript:void(0)"
                      (click)="signupType('phone')"
                      >Signup By Mobile</a
                    >
                  </li>
                  <li>
                    <a
                      [ngClass]="{ active: registerByEmail }"
                      href="javascript:void(0)"
                      class="active"
                      (click)="signupType('email')"
                      >Signup By Email</a
                    >
                  </li>
                </ul>
              </div>
              <div
                class="form-group position-relative mb-4"
                *ngIf="registerByMobile"
              >
                <label>Mobile Number</label>
                <div class="code-outer selectdiv">
                  <input
                    #input
                    placeholder="{{
                      'SIGNUP_INFO.PLACEHOLDER_MOBILE' | translate
                    }}"
                    (ngModelChange)="onInputChange($event)"
                    type="text"
                    pattern="^[0-9 ][0-9 ]{3,15}$"
                    maxlength="15"
                    #phone="ngModel"
                    (hasError)="hasError($event)"
                    [(ngModel)]="model.phone"
                    name="phone"
                    (countryChange)="onCountryChange($event)"
                    (ng2TelOutput)="getNumber($event)"
                    (intlTelInputObject)="telInputObject($event)"
                    ng2TelInput
                    required
                  />
                </div>
                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="phone.errors && (phone.dirty || signForm.submitted)"
                >
                  <p class="mb-0" *ngIf="phone.errors.required">
                    {{ "SIGNUP_INFO.MOBILE_REQUIRED" | translate }}
                  </p>

                  <p class="mb-0 red-text" *ngIf="phone.errors.pattern">
                    {{ "SIGNUP_INFO.VALID_MOBILE" | translate }}
                  </p>
                </div>

                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="!btnDisable && signForm.submitted"
                >
                  <p
                    class="mb-0 red-text"
                    *ngIf="
                      !btnDisable &&
                      !phone.errors?.required &&
                      !phone?.errors?.pattern
                    "
                  >
                    {{ "SIGNUP_INFO.VALID_MOBILE" | translate }}
                  </p>
                </div>
              </div>

              <div
                class="form-group position-relative mb-4"
                *ngIf="registerByEmail"
              >
                <div>
                  <label>Email</label>
                  <div class="field-icon">
                    <span class="mdi mdi-email-outline"></span>
                  </div>
                  <input
                    type="email"
                    class="form-control text-fields-gray with-icon-field"
                    placeholder="{{
                      'SIGNUP_INFO.PLACEHOLDER_EMAIL' | translate
                    }}"
                    (keyup)="trimNumber($event, 'email')"
                    [(ngModel)]="model.email"
                    name="email"
                    pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,8}$"
                    #email="ngModel"
                    maxlength="255"
                    required
                  />
                </div>
                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="email.errors && (email.dirty || signForm.submitted)"
                >
                  <p class="mb-0" *ngIf="email.errors.required">
                    {{ "SIGNUP_INFO.EMAIL_REQUIRED" | translate }}
                  </p>
                  <p class="mb-0 red-text" *ngIf="email.errors.pattern">
                    {{ "SIGNUP_INFO.INVALID_EMAIL" | translate }}
                  </p>
                </div>
              </div>
              <div class="form-group d-flex justify-content-center">
                <button
                  [ngClass]="{ disabled: !btnDisable }"
                  class="btn btn-theme btn-login"
                  [disabled]="!signForm.valid"
                  href="javascript:void(0)"
                >
                  <span class="spin icon-loader" *ngIf="isLoading"> </span>
                  {{ "SIGNUP_INFO.SEND_OTP" | translate }}
                </button>
              </div>
            </form>
            <!-- social login -->
            <div class="form-group social-login text-center mt-2">
              <p>{{ "LOGIN_INFO.OR_CONNECT_USING" | translate }}</p>
              <div class="d-flex justify-content-center">
                <button
                  class="btn login-with-google mr-2"
                  (click)="socialLogin.signInWithGoogle()"
                >
                  <span class="icon-google-plus"></span>
                </button>
                <button
                  class="btn login-with-facebook mb-0"
                  (click)="socialLogin.signInWithFB()"
                >
                  <span class="material-icons">facebook</span>
                </button>
              </div>
            </div>
            <div class="bottom-signup text-center pt-2">
              <span class="d-block mb-2">
                {{ "SIGNUP_INFO.ALREADY_HAVE_AN_ACCOUNT?" | translate }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
